import React, { useState, useEffect } from 'react';

// Direct dynamic import approach
const loadTeamSettingsComponent = async () => {
  try {
    const module = await import('@workboard/ui-team-settings');
    return module.TeamSettingsPage;
  } catch (error) {
    console.error('📦 Import failed:', error);
    return null;
  }
};

export interface TeamSettingsAdminPageProps {
  orgId: number;
}

const TeamSettingsAdminPage: React.FC<TeamSettingsAdminPageProps> = ({ orgId }) => {
  const [component, setComponent] = useState<React.ComponentType<any> | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    loadTeamSettingsComponent()
      .then((TeamSettingsComponent) => {
        if (TeamSettingsComponent) {
          setComponent(() => TeamSettingsComponent);
        } else {
          setError('Failed to load TeamSettingsPage component');
        }
      })
      .catch((err) => {
        console.error('❌ Error loading component:', err);
        setError(err.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [orgId]);

  if (isLoading) {
    return (
      <div style={{ width: '100%', padding: '20px' }}>
        <div style={{ padding: '40px', textAlign: 'center', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
          <h3 style={{ color: '#666', marginBottom: '15px' }}>🔄 Loading Team Settings...</h3>
          <div style={{ width: '40px', height: '40px', border: '4px solid #f3f3f3', borderTop: '4px solid #007bff', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '20px auto' }}></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ width: '100%', padding: '20px' }}>
        <div style={{ padding: '20px', backgroundColor: '#f8d7da', border: '1px solid #f5c6cb', borderRadius: '4px', color: '#721c24' }}>
          <h4>❌ Failed to Load Team Settings</h4>
          <p>Error: {error}</p>
        </div>
      </div>
    );
  }

  if (component) {
    return (
      <div style={{ width: '100%', padding: '20px' }}>
        {React.createElement(component, {
          orgId,
          onSettingsChange: (settings: any) => {
            console.log('📝 Team settings changed:', settings);
          },
          onError: (error: any) => {
            console.error('❌ Team settings error:', error);
          },
          onToast: (toast: any) => {
            console.log('🍞 Toast:', toast);
          }
        })}
      </div>
    );
  }

  return (
    <div style={{ width: '100%', padding: '20px' }}>
      <div style={{ padding: '20px', backgroundColor: '#f8d7da', border: '1px solid #f5c6cb', borderRadius: '4px', color: '#721c24' }}>
        <h4>❌ Unexpected State</h4>
        <p>Component loaded but not rendering. This should not happen.</p>
      </div>
    </div>
  );
};

export default TeamSettingsAdminPage;